export const OBJECT_CATEGORIES = {
  COMMUNICATION: 'COMMUNICATION',
  REMOTE_SENSING: 'REMOTE_SENSING',
  NAVIGATION: 'NAVIGATION',
  SCIENTIFIC: 'SCIENTIFIC',
  LAUNCH_SYSTEM: 'LAUNCH_SYSTEM',
  SPACE_TUG: 'SPACE_TUG',
  HUMAN_TRANSPORTATION: 'HUMAN_TRANSPORTATION',
  TELESCOPE: 'TELESCOPE',
  SPACE_STATION: 'SPACE_STATION',
  MISSION_RELATED_OBJECT: 'MISSION_RELATED_OBJECT',
  SPACE_PROBE: 'SPACE_PROBE',
  PLANETARY_VEHICLE: 'PLANETARY_VEHICLE',
  ANY_OTHER: 'ANY_OTHER',
};

export type ObjectCategory = (typeof OBJECT_CATEGORIES)[keyof typeof OBJECT_CATEGORIES];
